import { getEmployeeAppraisalFilterAppraisal1 } from "./action";
import {
  GET_BD_USER,
  GET_DEPARTMENT,
  GET_PROJECT_LIST,
  ADD_TASK,
  GET_TASK,
  GET_TASK_CATEGORY,
  GET_TASK_EXPORT,
  GET_FEASIBILITY_REPORT_DETAIL,
  UPDATE_TASK_OWNER,
  UPDATE_TASK_START,
  UPDATE_TASK_COMPLETED,
  GET_TASK_DETAIL,
  GET_TASK_PROJECT_FILTER,
  GET_TASK_CATEGORY_FILTER,
  GET_TASK_DEPARTMENT_FILTER,
  GET_TASK_OWNER_FILTER,
  GET_USER_DESIGNATION,
  GET_USER_ROLE_FUNCTIONALITY,
  CREATE_USER_ROLE_FUNCTIONALITY,
  GET_PUBLIC_HOLIDAY_LIST,
  GET_YEAR,
  GET_SALARY_ADVANCE_DEDUCTION_HISTORY,
  GET_SALARY_ADVANCE_EXPORT,
  GET_SALARY_ADVANCE,
  GET_OUT_PASS,
  GET_EMPLOYEE,
  GET_OUT_PASS_EXPORT,
  GET_OUT_PASS_DETAILS,
  GET_OUT_PASS_FILTER_DEPARTMENT,
  GET_OUT_PASS_FILTER_EMPLOYEE,
  GET_OUT_PASS_FILTER_STATUS,
  GET_EMPLOYEE_ATTENDANCE,
  GET_LEAVE_TYPE,
  GET_EMPLOYEE_CHECKIN,
  GET_PETTY_CASH,
  GET_PETTY_CASH_MASTER_EXPORT,
  GET_LEAVE_SUMMARY,
  GET_COMP_OFF_LEAVE_SUMMARY,
  GET_VEHICLE_SERVICE_REQUEST,
  GET_VECHICLE_TYPE,
  GET_SERVICE_TYPE,
  GET_EMPLOYEE_ATTENDANCE_EXPORT,
  GET_VEHICLE_SERVICE_REQUEST_EXPORT,
  GET_VEHICLE_NUMBER,
  GET_GST,
  GET_ASSEST_TYPE,
  GET_DESIGNATION,
  GET_DESIGNATION_EXPORT,
  GET_DEPARTMENT_MASTER,
  GET_DEPARTMENT_EXPORT,
  GET_LEVEL,
  GET_LEVEL_EXPORT,
  GET_JOB_ROLE,
  GET_DEPARTMENT_DESIGNATION,
  GET_TASK_ACCOUNTABLE_FILTER,
  GET_APPRAISAL_QUESTION_EXPORT,
  GET_APPRAISAL_QUESTION_OPTION,
  GET_APPRAISAL_QUESTION_OPTION_EXPORT,
  GET_EMPLOYEE_APPRAISAL_QUESTION,
  GET_EMPLOYEE_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_EXPORT,
  GET_APPRAISAL_QUESTION,
  GET_APPRAISAL,
  GET_APPRAISAL_CATEGORY,
  GET_APPRAISAL_RATING,
  GET_QUESTION,
  GET_QUESTION_VALUE,
  GET_QUESTION_VALUE_SET,
  GET_APPRAISAL_QUESTION_PRINT,
  GET_HR_LEAVE_TYPE,
  GET_EMPLOYEE_APPRAISAL_QUESTION_PRINT,
  GET_TO_DO_CATEGORY,
  GET_HR_APPRAISAL_QUESTION_DESIGNATION_FOR_UPDATE,
  GET_HR_APPRAISAL_QUESTION_DESIGNATION,
  GET_APPRAISAL_RATING_EXPORT,
  GET_APPRAISAL_QUESTION_CATEGORY_FILTER,
  GET_APPRAISAL_QUESTION_DEPARTMENT_FILTER,
  GET_APPRAISAL_QUESTION_DESIGNATION_FILTER,
  GET_HR_APPRAISAL_QUESTION_OPTION,
  GET_HR_APPRAISAL_QUESTION_OPTION_DETAIL,
  GET_EMPLOYEE1,
  GET_EMPLOYEE_FOR_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_FILTER_EMPLOYEE,
  GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL1,
  GET_EMPLOYEE_DEPARTMENT_FOR_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_FILTER_DEPARTMENT,
  GET_EMPLOYEE_APPRAISAL_FILTER_DESGINATION,
  GET_EMPLOYEE_APPRAISAL_DETAIL,
  GET_PENDING_TODO,
  GET_USER_ROLE_FUNCTIONALITY_DETAIL,
  GET_USER_ROLE_FUNCTIONALITY_FILTER_DEPARTMENT,
  GET_USER_ROLE_FUNCTIONALITY_FILTER_DESIGNATION,
  GET_USER_BATA,
  GET_USER_BATA_FILTER_USER,
  GET_USER_BATA_EXPORT,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_DEPARTMENT,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_EMPLOYEE,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_EXPORT,
  GET_EMPLOYEE_FINAL_SETTLEMENT_DETAIL,
  GET_EMPLOYEE_FINAL_SETTLEMENT_PRINT,
  GET_HR_SALARY_ADVANCE_FILTER_DEPARTMENT,
  GET_HR_SALARY_ADVANCE_FILTER_USER,
  GET_HR_SALARY_ADVANCE_DETAIL,
  GET_SETTING_ITEM,
  GET_ADMIN_SETTING,
  GET_SETTING_ITEM_OPTION,
  GET_ADMIN_SETTING_VALUE,
  GET_ADMIN_SETTING_DETAILS,
  GET_SALARY_SLIP_FILTER_EMPLOYEE_TYPE,
  GET_SALARY_SLIP_FILTER_EMPLOYEE,
  GET_SALARY_SLIP,
  GET_SALARY_SLIP_EXPORT,
  GET_SALARY_SLIP_FILTER_DEPARTMENT,
  GET_EMPLOYEE_APPRAISAL_QUESTION_DETAIL,
  GET_SALARY_SLIP_DETAIL,
  GET_SALARY_FOR_SALARY_ADVANCE,
  GET_FORM_16,
  GET_FINANCIAL_YEAR_FOR_FORM,
  GET_FORM_16_FILTER_USER,
  GET_FORM_16_FILTER_DEPARTMENT,
  GET_FORM_16_FILTER_YEAR,
  //vehicle request and service
  GET_FUEL_REQUEST,
  GET_FUEL_REQUEST_DETAIL,
  GET_FUEL_REQUEST_EXPORT,
  GET_VEHICLE_FOR_SERVICE,
  GET_ASSET_TYPE_FOR_SERVICE,
  GET_ASSET_FOR_SERVICE,
  GET_CARD_FOR_SERVICE,
  GET_VEHICLE_DETAIL_FOR_SERVICE,
  UPDATE_FUEL_REQUEST_FILTER_REQUEST_BY,
  UPDATE_FUEL_REQUEST_FILTER_PROJECT,
  GET_SERVICE_TYPE_FOR_SERVICE,
  GET_VEHICLE_SERVICE_REQUEST_DETAIL,
  GET_VEHICLE_SERVICE_REQUEST_FILTER_REQUESTED_BY,
  GET_VEHICLE_EXPORT,
  GET_VEHICLE,
  GET_VEHICLE_FILTER_OWNER,
  GET_VEHICLE_DETAIL_FOR_FUEL_REQUEST,
  GET_PROFESSIONAL_TAX_MASTER,
  GET_PROVIDENT_FUND_MASTER,
  GET_ESI_MASTER,
  GET_HR_LEAVE_SUMMARY,
  GET_LEAVE_SUMMARY_FILTER_EMPLOYEE,
  GET_HR_LEAVE_SUMMARY_TYPE,
  GET_HR_EMPLOYEE_PROFILE,
  GET_HR_USER_SHIFT,
  GET_SALARY_COMPONENT,
  GET_SALARY_COMPONENT_EXPORT,
  GET_PASSWORD_ITEM,
  GET_COMPANY_PASSWORD,
  GET_STOCK_COMPANY,
  GET_COMPANY_PASSWORD_ITEM_FILTER,
  GET_COMPANY_PASSWORD_COMPANY_FILTER,
  GET_VEHICLE_SERVICE_REQUEST_FILTER_COMPANY,
  GET_USERS,
  GET_MFA_PURPOSE,
  GET_USER_ROLE_MASTER,
  GET_EMPLOYEE_SHIFT_MASTER,
  GET_STOCK_LOCATION_MASTER,
  GET_USER_DETAIL,
  //travel Planning
  GET_TRAVEL_PLAN,
  GET_TRAVEL_PLAN_DEATIL,
  GET_DRIVER_FOR_TRAVEL_PLAN,
  // Salary Structure
  GET_SALARY_STRUCTURE,
  GET_COMPONENT_CALCULATION,
  GET_SALARY_STRUCTURE_DETAIL,
  GET_HR_EMPLOYEE,
  // Attendance Location Permission
  GET_ATTENDANCE_LOCATION_PERMISSION,
  GET_ATTENDANCE_LOCATION_PERMISSION_ITEM,
  GET_ATTENDANCE_LOCATION_PERMISSION_DETAIL,
  GET_ATTENDANCE_LOCATION_PERMISSION_EXPORT,
  GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_USER,
  GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_LOCATION,
  // Employee cheackin
  GET_EMPLOYEE_CHECKIN_REFERENCE,
  GET_EMPLOYEE_CHECKIN_REFERENCE_EXPORT,
  // HR Employee Details
  GET_HR_EMPLOYEE_BASIC_DETAILS,
  GET_HR_EMPLOYEE_BASIC_DETAILS_EXPORT,
  GET_HR_EMPLOYEMENT_TYPE,
  GET_HR_EMPLOYEE_EDUCATION_DETAILS,
  GET_HR_EMPLOYEE_EXPERIENCE_DETAILS,
  GET_HR_EMPLOYEE_RELATIONSHIP,
  GET_HR_EMPLOYEE_COMPLIANCE,
  GET_EMPLOYEE_FAMILY,
  GET_HR_EMPLOYEE_DETAILS,
  GET_HR_EMPLOYEE_STATUS,
  GET_HR_EMPLOYEE_FILTER_COMPANY,
  GET_HR_EMPLOYEE_FILTER_DEPARTMENT,
  GET_HR_EMPLOYEE_FILTER_DESIGNATIONS,
  // AttendanceRegularization
  GET_ATTENDANCE_REGULARIZATION,
  GET_ATTENDANCE_REGULARIZATION_EXPORT,
  GET_ATTENDANCE_REGULARIZATION_DETAIL,
  GET_ATTENDANCE_REGULARIZATION_FILTER_DEPARTMENT,
  GET_ATTENDANCE_REGULARIZATION_FILTER_EMPLOYEE,
  GET_ATTENDANCE_REGULARIZATION_FILTER_STATUS,
  // Hr Employee Attendance
  GET_HR_EMPLOYEE_ATTENDANCE,
  GET_HR_EMPLOYEE_ATTENDANCE_EXPORT,
  // User Check In
  GET_USER_CHECK_IN_TIME,
  GET_USER_CHECK_IN,
  GET_USER_CHECK_IN_FILTER_USER,
  GET_USER_CHECK_IN_FILTER_DEPARTMENT,
  GET_USER_CHECK_IN_EXPORT
} from "./types";
const initialStateChart = {
  labels: [],
  datasets: []
};
const initialState = {
  projectAuthority: [],
  // civilResourceTypePlanning : initialStateChart,
  // civilBudgetPlanning : initialStateChart,
  user: [],
  projectList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  departmentList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  feasibilityReportDetail: [],
  createTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateTaskOwner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateTaskStart: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateTaskComplete: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskProjectFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskCategoryFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskDepartmentFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskOwnerFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionality: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  createUserRoleFunctionality: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPublicHolidayList: {
    error: false,
    message: "",
    data: []
  },
  getYear: {
    error: false,
    message: "",
    data: []
  },
  getSalaryAdvanceMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryAdvanceMasterExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryAdvanceDeductionHistory: {
    error: false,
    message: "",
    data: []
  },
  getOutPass: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOutPassExport: {
    error: false,
    message: "",
    data: []
  },
  getOutPassDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOutPassFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOutPassFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOutPassFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAttendance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeaveType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeCheckin: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashMaster: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashMasterExport: {
    error: false,
    message: "",
    data: []
  },
  getLeaveSummary: {
    error: false,
    message: "",
    data: []
  },
  getCompOffLeaveSummary: {
    error: false,
    message: "",
    data: []
  },
  getVehicleServiceRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getServiceType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAttendanceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleServiceRequestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGst: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDesignationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDepartmentMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDepartmentExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLevelExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getJobRole: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLevel: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDepartmentDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskAccountableFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestion: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionOptionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalQuestion: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalRating: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFeedbackQuestion: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getFeedbackQuestionOptionValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getFeedbackQuestionOptionValueSet: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrLeaveType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalQuestionPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getToDoCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrAppraisalQuestionDesignationForUpdate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getHrAppraisalQuestionDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalRatingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionCategoryFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionDepartmentFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionDesignationFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrAppraisalQuestionOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrAppraisalQuestionOptionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeForAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeDepartmentForAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterDesgination: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPendingToDo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionalityDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionalityFilterDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionalityFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserBata: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserBataFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserBataExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //full and final
  getEmployeeFinalSettlement: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrSalaryAdvanceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrSalaryAdvanceFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrSalaryAdvanceFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdmSettingValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSettingItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdmSetting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSettingItemOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdmSettingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //SALARY SLIP
  getSalarySlip: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipFilterEmployeeType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalQuestionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryForSalaryAdvance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getForm16: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFinancialYearForForm16: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getForm16FilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getForm16FilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getForm16FilterFinancialYear: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //vehicle fuel
  getFuelRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFuelRequestDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFuelRequestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleForService: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTypeForService: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTypeService: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleDetailForService: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleDetailForFuelRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getServiceTypeForService: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleServiceRequestDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleServiceRequestFilterRequestedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicle: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleFilterOwner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProfessionalTaxMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProvidentFundMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEsiMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHRLeaveSummary: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeaveSummaryFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrLeaveSummaryType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrUserShift: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryComponent: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryComponentExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPasswordItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyPassword: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStockCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyPasswordItemFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyPasswordCompanyFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleServiceRequestFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUsers: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMFAPurpose: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeShiftMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStockLocationMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Hr Travel Planning
  getTravelPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTravelPlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDriverForTravelPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Salary Structure Vishal
  getSalaryStructure: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getComponentCalculation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryStructureDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Attendance Location Permission
  getAttendanceLocationPermission: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocationPermissionItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocationPermissionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocationPermissionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocationPermissionFilterLocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocationPermissionFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceLocationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // HR Employee Details
  getHrEmployeeBasicDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeBasicDetailsExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmploymentType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeEducationDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeExperienceDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeRelationship: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeCompliance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFamily: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeFilterDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // AttendanceRegularization
  getAttendanceRegularizationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceRegularizationDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceRegularizationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceRegularizationFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceRegularizationFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendanceRegularizationFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Hr Employee Attendance
  getHrEmployeeAttendance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrEmployeeAttendanceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // User Check In
  getUserCheckInTime: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserCheckInExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserCheckinFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserCheckIn: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserCheckinFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const HR_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BD_USER:
      return Object.assign({}, state, { user: payload });
    case GET_DEPARTMENT:
      return Object.assign({}, state, { departmentList: payload });
    case GET_PROJECT_LIST:
      return Object.assign({}, state, { projectList: payload });
    case ADD_TASK:
      return Object.assign({}, state, { createTask: payload });
    case GET_TASK:
      return Object.assign({}, state, { getTask: payload });
    case GET_TASK_CATEGORY:
      return Object.assign({}, state, { getTaskCategory: payload });
    case GET_TASK_EXPORT:
      return Object.assign({}, state, { getTaskExport: payload });
    case GET_FEASIBILITY_REPORT_DETAIL:
      return Object.assign({}, state, { feasibilityReportDetail: payload });
    case UPDATE_TASK_OWNER:
      return Object.assign({}, state, { updateTaskOwner: payload });
    case UPDATE_TASK_START:
      return Object.assign({}, state, { updateTaskStart: payload });
    case UPDATE_TASK_COMPLETED:
      return Object.assign({}, state, { updateTaskComplete: payload });
    case GET_TASK_DETAIL:
      return Object.assign({}, state, { getTaskDetail: payload });
    case GET_TASK_PROJECT_FILTER:
      return Object.assign({}, state, { getTaskProjectFilter: payload });
    case GET_TASK_CATEGORY_FILTER:
      return Object.assign({}, state, { getTaskCategoryFilter: payload });
    case GET_TASK_DEPARTMENT_FILTER:
      return Object.assign({}, state, { getTaskDepartmentFilter: payload });
    case GET_TASK_OWNER_FILTER:
      return Object.assign({}, state, { getTaskOwnerFilter: payload });
    case GET_USER_DESIGNATION:
      return Object.assign({}, state, { getUserDesignation: payload });
    case GET_USER_ROLE_FUNCTIONALITY:
      return Object.assign({}, state, { getUserRoleFunctionality: payload });
    case CREATE_USER_ROLE_FUNCTIONALITY:
      return Object.assign({}, state, { createUserRoleFunctionality: payload });
    case GET_PUBLIC_HOLIDAY_LIST:
      return Object.assign({}, state, { getPublicHolidayList: payload });
    case GET_YEAR:
      return Object.assign({}, state, { getYear: payload });
    case GET_SALARY_ADVANCE:
      return Object.assign({}, state, { getSalaryAdvanceMaster: payload });
    case GET_SALARY_ADVANCE_DEDUCTION_HISTORY:
      return Object.assign({}, state, {
        getSalaryAdvanceDeductionHistory: payload
      });
    case GET_SALARY_ADVANCE_EXPORT:
      return Object.assign({}, state, {
        getSalaryAdvanceMasterExport: payload
      });
    case GET_OUT_PASS:
      return Object.assign({}, state, { getOutPass: payload });
    case GET_EMPLOYEE:
      return Object.assign({}, state, { getEmployee: payload });
    case GET_OUT_PASS_EXPORT:
      return Object.assign({}, state, { getOutPassExport: payload });
    case GET_OUT_PASS_DETAILS:
      return Object.assign({}, state, {
        getOutPassDetail: payload
      });
    case GET_OUT_PASS_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getOutPassFilterDepartment: payload
      });
    case GET_OUT_PASS_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getOutPassFilterEmployee: payload
      });
    case GET_OUT_PASS_FILTER_STATUS:
      return Object.assign({}, state, {
        getOutPassFilterStatus: payload
      });
    case GET_EMPLOYEE_ATTENDANCE:
      return Object.assign({}, state, { getEmployeeAttendance: payload });
    case GET_LEAVE_TYPE:
      return Object.assign({}, state, { getLeaveType: payload });
    case GET_EMPLOYEE_CHECKIN:
      return Object.assign({}, state, { getEmployeeCheckin: payload });
    case GET_PETTY_CASH:
      return Object.assign({}, state, { getPettyCashMaster: payload });
    case GET_PETTY_CASH_MASTER_EXPORT:
      return Object.assign({}, state, { getPettyCashMasterExport: payload });
    case GET_LEAVE_SUMMARY:
      return Object.assign({}, state, { getLeaveSummary: payload });
    case GET_COMP_OFF_LEAVE_SUMMARY:
      return Object.assign({}, state, { getCompOffLeaveSummary: payload });
    case GET_VEHICLE_SERVICE_REQUEST:
      return Object.assign({}, state, { getVehicleServiceRequest: payload });
    case GET_VECHICLE_TYPE:
      return Object.assign({}, state, { getVehicleType: payload });
    case GET_SERVICE_TYPE:
      return Object.assign({}, state, { getServiceType: payload });
    case GET_EMPLOYEE_ATTENDANCE_EXPORT:
      return Object.assign({}, state, { getEmployeeAttendanceExport: payload });
    case GET_VEHICLE_SERVICE_REQUEST_EXPORT:
      return Object.assign({}, state, {
        getVehicleServiceRequestExport: payload
      });
    case GET_VEHICLE_NUMBER:
      return Object.assign({}, state, { getVehicleNumber: payload });
    case GET_GST:
      return Object.assign({}, state, { getGst: payload });
    case GET_ASSEST_TYPE:
      return Object.assign({}, state, { getAssetType: payload });
    case GET_DESIGNATION:
      return Object.assign({}, state, { getDesignation: payload });
    case GET_DESIGNATION_EXPORT:
      return Object.assign({}, state, { getDesignationExport: payload });
    case GET_DEPARTMENT_MASTER:
      return Object.assign({}, state, { getDepartmentMaster: payload });
    case GET_DEPARTMENT_EXPORT:
      return Object.assign({}, state, { getDepartmentExport: payload });
    case GET_LEVEL:
      return Object.assign({}, state, { getLevel: payload });
    case GET_LEVEL_EXPORT:
      return Object.assign({}, state, { getLevelExport: payload });
    case GET_JOB_ROLE:
      return Object.assign({}, state, { getJobRole: payload });
    case GET_DEPARTMENT_DESIGNATION:
      return Object.assign({}, state, { getDepartmentDesignation: payload });
    case GET_TASK_ACCOUNTABLE_FILTER:
      return Object.assign({}, state, { getTaskAccountableFilter: payload });
    case GET_APPRAISAL_QUESTION:
      return Object.assign({}, state, { getAppraisalQuestion: payload });
    case GET_APPRAISAL_QUESTION_EXPORT:
      return Object.assign({}, state, { getAppraisalQuestionExport: payload });
    case GET_APPRAISAL_QUESTION_OPTION:
      return Object.assign({}, state, { getAppraisalQuestionOption: payload });
    case GET_APPRAISAL_QUESTION_OPTION_EXPORT:
      return Object.assign({}, state, {
        getAppraisalQuestionOptionExport: payload
      });
    case GET_EMPLOYEE_APPRAISAL_QUESTION:
      return Object.assign({}, state, {
        getEmployeeAppraisalQuestion: payload
      });
    case GET_EMPLOYEE_APPRAISAL:
      return Object.assign({}, state, { getEmployeeAppraisal: payload });
    case GET_EMPLOYEE_APPRAISAL_EXPORT:
      return Object.assign({}, state, { getEmployeeAppraisalExport: payload });
    case GET_APPRAISAL:
      return Object.assign({}, state, { getAppraisal: payload });
    case GET_APPRAISAL_CATEGORY:
      return Object.assign({}, state, { getAppraisalCategory: payload });
    case GET_APPRAISAL_RATING:
      return Object.assign({}, state, { getAppraisalRating: payload });
    case GET_QUESTION:
      return Object.assign({}, state, { getFeedbackQuestion: payload });
    case GET_QUESTION_VALUE:
      return Object.assign({}, state, {
        getFeedbackQuestionOptionValue: payload
      });
    case GET_QUESTION_VALUE_SET:
      return Object.assign({}, state, {
        getFeedbackQuestionOptionValueSet: payload
      });
    case GET_APPRAISAL_QUESTION_PRINT:
      return Object.assign({}, state, { getAppraisalQuestionPrint: payload });
    case GET_HR_LEAVE_TYPE:
      return Object.assign({}, state, { getHrLeaveType: payload });
    case GET_EMPLOYEE_APPRAISAL_QUESTION_PRINT:
      return Object.assign({}, state, {
        getEmployeeAppraisalQuestionPrint: payload
      });
    case GET_TO_DO_CATEGORY:
      return Object.assign({}, state, { getToDoCategory: payload });
    case GET_HR_APPRAISAL_QUESTION_DESIGNATION_FOR_UPDATE:
      return Object.assign({}, state, {
        getHrAppraisalQuestionDesignationForUpdate: payload
      });
    case GET_HR_APPRAISAL_QUESTION_DESIGNATION:
      return Object.assign({}, state, {
        getHrAppraisalQuestionDesignation: payload
      });
    case GET_APPRAISAL_RATING_EXPORT:
      return Object.assign({}, state, { getAppraisalRatingExport: payload });
    case GET_APPRAISAL_QUESTION_CATEGORY_FILTER:
      return Object.assign({}, state, {
        getAppraisalQuestionCategoryFilter: payload
      });
    case GET_APPRAISAL_QUESTION_DEPARTMENT_FILTER:
      return Object.assign({}, state, {
        getAppraisalQuestionDepartmentFilter: payload
      });
    case GET_APPRAISAL_QUESTION_DESIGNATION_FILTER:
      return Object.assign({}, state, {
        getAppraisalQuestionDesignationFilter: payload
      });
    case GET_HR_APPRAISAL_QUESTION_OPTION:
      return Object.assign({}, state, {
        getHrAppraisalQuestionOption: payload
      });
    case GET_HR_APPRAISAL_QUESTION_OPTION_DETAIL:
      return Object.assign({}, state, {
        getHrAppraisalQuestionOptionDetail: payload
      });
    case GET_EMPLOYEE_FOR_APPRAISAL:
      return Object.assign({}, state, { getEmployeeForAppraisal: payload });
    case GET_EMPLOYEE_APPRAISAL_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterEmployee: payload
      });
    case GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterAppraisal: payload
      });
    case GET_EMPLOYEE_DEPARTMENT_FOR_APPRAISAL:
      return Object.assign({}, state, {
        getEmployeeDepartmentForAppraisal: payload
      });
    case GET_EMPLOYEE_APPRAISAL_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterDepartment: payload
      });
    case GET_EMPLOYEE_APPRAISAL_FILTER_DESGINATION:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterDesgination: payload
      });

    case GET_EMPLOYEE_APPRAISAL_DETAIL:
      return Object.assign({}, state, { getEmployeeAppraisalDetail: payload });
    case GET_PENDING_TODO:
      return Object.assign({}, state, { getPendingToDo: payload });
    case GET_USER_ROLE_FUNCTIONALITY_DETAIL:
      return Object.assign({}, state, {
        getUserRoleFunctionalityDetail: payload
      });
    case GET_USER_ROLE_FUNCTIONALITY_FILTER_DESIGNATION:
      return Object.assign({}, state, {
        getUserRoleFunctionalityFilterDesignation: payload
      });
    case GET_USER_ROLE_FUNCTIONALITY_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getUserRoleFunctionalityFilterDepartment: payload
      });
    case GET_USER_BATA:
      return Object.assign({}, state, {
        getUserBata: payload
      });
    case GET_USER_BATA_FILTER_USER:
      return Object.assign({}, state, {
        getUserBataFilterUser: payload
      });
    case GET_USER_BATA_EXPORT:
      return Object.assign({}, state, {
        getUserBataExport: payload
      });

    //full and final
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlement: payload
      });
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementFilterDepartment: payload
      });
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementFilterEmployee: payload
      });
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_EXPORT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementExport: payload
      });
    case GET_EMPLOYEE_FINAL_SETTLEMENT_DETAIL:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementDetail: payload
      });
    case GET_EMPLOYEE_FINAL_SETTLEMENT_PRINT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementPrint: payload
      });

    //SALARY ADVANCE
    case GET_HR_SALARY_ADVANCE_DETAIL:
      return Object.assign({}, state, {
        getHrSalaryAdvanceDetail: payload
      });
    case GET_HR_SALARY_ADVANCE_FILTER_USER:
      return Object.assign({}, state, {
        getHrSalaryAdvanceFilterUser: payload
      });
    case GET_HR_SALARY_ADVANCE_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getHrSalaryAdvanceFilterDepartment: payload
      });
    case GET_ADMIN_SETTING_VALUE:
      return Object.assign({}, state, {
        getAdmSettingValue: payload
      });
    case GET_SETTING_ITEM:
      return Object.assign({}, state, {
        getSettingItem: payload
      });
    case GET_ADMIN_SETTING:
      return Object.assign({}, state, {
        getAdmSetting: payload
      });
    case GET_SETTING_ITEM_OPTION:
      return Object.assign({}, state, {
        getSettingItemOption: payload
      });
    case GET_ADMIN_SETTING_DETAILS:
      return Object.assign({}, state, {
        getAdmSettingDetail: payload
      });

    //SALARY SLIP
    case GET_SALARY_SLIP:
      return Object.assign({}, state, {
        getSalarySlip: payload
      });

    case GET_SALARY_SLIP_EXPORT:
      return Object.assign({}, state, {
        getSalarySlipExport: payload
      });

    case GET_SALARY_SLIP_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getSalarySlipFilterDepartment: payload
      });

    case GET_SALARY_SLIP_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getSalarySlipFilterEmployee: payload
      });
    case GET_SALARY_SLIP_FILTER_EMPLOYEE_TYPE:
      return Object.assign({}, state, {
        getSalarySlipFilterEmployeeType: payload
      });

    case GET_EMPLOYEE_APPRAISAL_QUESTION_DETAIL:
      return Object.assign({}, state, {
        getEmployeeAppraisalQuestionDetail: payload
      });

    case GET_SALARY_SLIP_DETAIL:
      return Object.assign({}, state, {
        getSalarySlipDetail: payload
      });

    case GET_SALARY_FOR_SALARY_ADVANCE:
      return Object.assign({}, state, {
        getSalaryForSalaryAdvance: payload
      });

    case GET_FORM_16:
      return Object.assign({}, state, {
        getForm16: payload
      });
    case GET_FINANCIAL_YEAR_FOR_FORM:
      return Object.assign({}, state, {
        getFinancialYearForForm16: payload
      });
    case GET_FORM_16_FILTER_USER:
      return Object.assign({}, state, {
        getForm16FilterUser: payload
      });
    case GET_FORM_16_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getForm16FilterDepartment: payload
      });

    case GET_FORM_16_FILTER_YEAR:
      return Object.assign({}, state, {
        getForm16FilterFinancialYear: payload
      });

    //vehicle request
    case GET_FUEL_REQUEST:
      return Object.assign({}, state, {
        getFuelRequest: payload
      });
    case GET_FUEL_REQUEST_DETAIL:
      return Object.assign({}, state, {
        getFuelRequestDetails: payload
      });
    case GET_FUEL_REQUEST_EXPORT:
      return Object.assign({}, state, {
        getFuelRequestExport: payload
      });
    case GET_VEHICLE_FOR_SERVICE:
      return Object.assign({}, state, {
        getVehicleForService: payload
      });
    case GET_ASSET_TYPE_FOR_SERVICE:
      return Object.assign({}, state, {
        getAssetTypeForService: payload
      });

    case GET_ASSET_FOR_SERVICE:
      return Object.assign({}, state, {
        getAssetTypeService: payload
      });

    case GET_CARD_FOR_SERVICE:
      return Object.assign({}, state, {
        getCardForService: payload
      });
    case GET_VEHICLE_DETAIL_FOR_SERVICE:
      return Object.assign({}, state, {
        getVehicleDetailForService: payload
      });
    case GET_VEHICLE_DETAIL_FOR_FUEL_REQUEST:
      return Object.assign({}, state, {
        getVehicleDetailForFuelRequest: payload
      });
    case UPDATE_FUEL_REQUEST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getFuelRequestFilterProject: payload
      });
    case UPDATE_FUEL_REQUEST_FILTER_REQUEST_BY:
      return Object.assign({}, state, {
        getFuelRequestFilterRequestedBy: payload
      });
    case GET_SERVICE_TYPE_FOR_SERVICE:
      return Object.assign({}, state, {
        getServiceTypeForService: payload
      });

    case GET_VEHICLE_SERVICE_REQUEST_DETAIL:
      return Object.assign({}, state, {
        getVehicleServiceRequestDetail: payload
      });
    case GET_VEHICLE_SERVICE_REQUEST_FILTER_REQUESTED_BY:
      return Object.assign({}, state, {
        getVehicleServiceRequestFilterRequestedBy: payload
      });
    case GET_VEHICLE:
      return Object.assign({}, state, {
        getVehicle: payload
      });

    case GET_VEHICLE_EXPORT:
      return Object.assign({}, state, {
        getVehicleExport: payload
      });
    case GET_VEHICLE_FILTER_OWNER:
      return Object.assign({}, state, {
        getVehicleFilterOwner: payload
      });
    case GET_PROFESSIONAL_TAX_MASTER:
      return Object.assign({}, state, {
        getProfessionalTaxMaster: payload
      });

    case GET_PROVIDENT_FUND_MASTER:
      return Object.assign({}, state, {
        getProvidentFundMaster: payload
      });

    case GET_ESI_MASTER:
      return Object.assign({}, state, {
        getEsiMaster: payload
      });

    case GET_HR_LEAVE_SUMMARY:
      return Object.assign({}, state, {
        getHRLeaveSummary: payload
      });

    case GET_LEAVE_SUMMARY_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getLeaveSummaryFilterEmployee: payload
      });

    case GET_HR_LEAVE_SUMMARY_TYPE:
      return Object.assign({}, state, {
        getHrLeaveSummaryType: payload
      });

    case GET_HR_EMPLOYEE_PROFILE:
      return Object.assign({}, state, {
        getHrEmployeeProfile: payload
      });

    case GET_HR_USER_SHIFT:
      return Object.assign({}, state, {
        getHrUserShift: payload
      });
    case GET_SALARY_COMPONENT:
      return Object.assign({}, state, {
        getSalaryComponent: payload
      });

    case GET_SALARY_COMPONENT_EXPORT:
      return Object.assign({}, state, {
        getSalaryComponentExport: payload
      });

    case GET_PASSWORD_ITEM:
      return Object.assign({}, state, {
        getPasswordItem: payload
      });

    case GET_COMPANY_PASSWORD:
      return Object.assign({}, state, {
        getCompanyPassword: payload
      });

    case GET_STOCK_COMPANY:
      return Object.assign({}, state, {
        getStockCompany: payload
      });

    case GET_COMPANY_PASSWORD_COMPANY_FILTER:
      return Object.assign({}, state, {
        getCompanyPasswordCompanyFilter: payload
      });

    case GET_COMPANY_PASSWORD_ITEM_FILTER:
      return Object.assign({}, state, {
        getCompanyPasswordItemFilter: payload
      });
    case GET_VEHICLE_SERVICE_REQUEST_FILTER_COMPANY:
      return Object.assign({}, state, {
        getVehicleServiceRequestFilterCompany: payload
      });
    case GET_USERS:
      return Object.assign({}, state, {
        getUsers: payload
      });
    case GET_MFA_PURPOSE:
      return Object.assign({}, state, {
        getMFAPurpose: payload
      });
    case GET_USER_ROLE_MASTER:
      return Object.assign({}, state, {
        getUserRoleMaster: payload
      });
    case GET_EMPLOYEE_SHIFT_MASTER:
      return Object.assign({}, state, {
        getEmployeeShiftMaster: payload
      });

    case GET_STOCK_LOCATION_MASTER:
      return Object.assign({}, state, {
        getStockLocationMaster: payload
      });
    case GET_USER_DETAIL:
      return Object.assign({}, state, {
        getUserDetails: payload
      });
    case GET_TRAVEL_PLAN:
      return Object.assign({}, state, {
        getTravelPlan: payload
      });
    case GET_TRAVEL_PLAN_DEATIL:
      return Object.assign({}, state, {
        getTravelPlanDetail: payload
      });
    case GET_DRIVER_FOR_TRAVEL_PLAN:
      return Object.assign({}, state, {
        getDriverForTravelPlan: payload
      });
    // Salary Structure Vishal
    case GET_SALARY_STRUCTURE:
      return Object.assign({}, state, {
        getSalaryStructure: payload
      });
    case GET_COMPONENT_CALCULATION:
      return Object.assign({}, state, {
        getComponentCalculation: payload
      });
    case GET_SALARY_STRUCTURE_DETAIL:
      return Object.assign({}, state, {
        getSalaryStructureDetail: payload
      });
    case GET_HR_EMPLOYEE:
      return Object.assign({}, state, {
        getHrEmployee: payload
      });
    // Attendance Location Permission

    case GET_ATTENDANCE_LOCATION_PERMISSION:
      return Object.assign({}, state, {
        getAttendanceLocationPermission: payload
      });
    case GET_ATTENDANCE_LOCATION_PERMISSION_ITEM:
      return Object.assign({}, state, {
        getAttendanceLocationPermissionItem: payload
      });
    case GET_ATTENDANCE_LOCATION_PERMISSION_DETAIL:
      return Object.assign({}, state, {
        getAttendanceLocationPermissionDetail: payload
      });
    case GET_ATTENDANCE_LOCATION_PERMISSION_EXPORT:
      return Object.assign({}, state, {
        getAttendanceLocationPermissionExport: payload
      });

    case GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_USER:
      return Object.assign({}, state, {
        getAttendanceLocationPermissionFilterUser: payload
      });
    case GET_ATTENDANCE_LOCATION_PERMISSION_FILTER_LOCATION:
      return Object.assign({}, state, {
        getAttendanceLocationPermissionFilterLocation: payload
      });
    case GET_EMPLOYEE_CHECKIN_REFERENCE:
      return Object.assign({}, state, {
        getAttendanceLocation: payload
      });
    case GET_EMPLOYEE_CHECKIN_REFERENCE_EXPORT:
      return Object.assign({}, state, {
        getAttendanceLocationExport: payload
      });
    // HR Employee Details
    case GET_HR_EMPLOYEE_BASIC_DETAILS:
      return Object.assign({}, state, {
        getHrEmployeeBasicDetails: payload
      });
    case GET_HR_EMPLOYEE_BASIC_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getHrEmployeeBasicDetailsExport: payload
      });
    case GET_HR_EMPLOYEMENT_TYPE:
      return Object.assign({}, state, {
        getHrEmploymentType: payload
      });
    case GET_HR_EMPLOYEE_EDUCATION_DETAILS:
      return Object.assign({}, state, {
        getHrEmployeeEducationDetails: payload
      });
    case GET_HR_EMPLOYEE_EXPERIENCE_DETAILS:
      return Object.assign({}, state, {
        getHrEmployeeExperienceDetails: payload
      });
    case GET_HR_EMPLOYEE_RELATIONSHIP:
      return Object.assign({}, state, {
        getHrEmployeeRelationship: payload
      });
    case GET_HR_EMPLOYEE_COMPLIANCE:
      return Object.assign({}, state, {
        getHrEmployeeCompliance: payload
      });
    case GET_EMPLOYEE_FAMILY:
      return Object.assign({}, state, {
        getEmployeeFamily: payload
      });
    case GET_HR_EMPLOYEE_DETAILS:
      return Object.assign({}, state, {
        getHrEmployeeDetail: payload
      });
    case GET_HR_EMPLOYEE_STATUS:
      return Object.assign({}, state, {
        getHrEmployeeStatus: payload
      });
    case GET_HR_EMPLOYEE_FILTER_COMPANY:
      return Object.assign({}, state, {
        getHrEmployeeFilterCompany: payload
      });
    case GET_HR_EMPLOYEE_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getHrEmployeeFilterDepartment: payload
      });
    case GET_HR_EMPLOYEE_FILTER_DESIGNATIONS:
      return Object.assign({}, state, {
        getHrEmployeeFilterDesignation: payload
      });
    // AttendanceRegularization
    case GET_ATTENDANCE_REGULARIZATION:
      return Object.assign({}, state, {
        getAttendanceRegularization: payload
      });
    case GET_ATTENDANCE_REGULARIZATION_EXPORT:
      return Object.assign({}, state, {
        getAttendanceRegularizationExport: payload
      });
    case GET_ATTENDANCE_REGULARIZATION_DETAIL:
      return Object.assign({}, state, {
        getAttendanceRegularizationDetail: payload
      });
    case GET_ATTENDANCE_REGULARIZATION_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAttendanceRegularizationFilterDepartment: payload
      });
    case GET_ATTENDANCE_REGULARIZATION_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getAttendanceRegularizationFilterEmployee: payload
      });
    case GET_ATTENDANCE_REGULARIZATION_FILTER_STATUS:
      return Object.assign({}, state, {
        getAttendanceRegularizationFilterStatus: payload
      });
    // Hr Employee Attendance
    case GET_HR_EMPLOYEE_ATTENDANCE:
      return Object.assign({}, state, {
        getHrEmployeeAttendance: payload
      });
    case GET_HR_EMPLOYEE_ATTENDANCE_EXPORT:
      return Object.assign({}, state, {
        getHrEmployeeAttendanceExport: payload
      });
    // User Check In
    case GET_USER_CHECK_IN_TIME:
      return Object.assign({}, state, {
        getUserCheckInTime: payload
      });
    case GET_USER_CHECK_IN:
      return Object.assign({}, state, {
        getUserCheckIn: payload
      });
    case GET_USER_CHECK_IN_FILTER_USER:
      return Object.assign({}, state, {
        getUserCheckinFilterUser: payload
      });
    case GET_USER_CHECK_IN_EXPORT:
      return Object.assign({}, state, {
        getUserCheckInExport: payload
      });
    case GET_USER_CHECK_IN_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getUserCheckinFilterDepartment: payload
      });
    default:
      return state;
  }
};
export default HR_reducer;
